import http from './api'

const route = '/versao/'

export default {
    showVersion: (tokencontrato, nomeVersao) => {
        return http.post(route + 'showVersion', {
            tokencontrato: tokencontrato,
            nomeVersao: nomeVersao,
        })
    },
}
